import { forwardRef } from 'react'
import { CopyButton, createPolymorphicComponent } from '@mantine/core'
import { useTranslation } from '@front/model'
import { TButton, type TButtonProps } from './button'

type ButtonCopyProps = Omit<TButtonProps, 'icon' | 'onClick'> & {
  value: string
}

const _ButtonCopy = forwardRef<HTMLButtonElement, ButtonCopyProps>(({ value, ...props }, ref) => {
  const { t } = useTranslation()
  return (
    <CopyButton value={value}>
      {({ copied, copy }) => {
        return (
          <TButton
            color={copied ? 'brand' : 'gray'}
            icon={copied ? 'check' : 'content_copy'}
            onClick={(e) => {
              e.stopPropagation()
              copy()
            }}
            tooltip={copied ? t('Copied') : t('Copy')}
            variant='ghost'
            {...props}
            ref={ref}
          />
        )
      }}
    </CopyButton>
  )
})

_ButtonCopy.displayName = 'ButtonCopy'

export const ButtonCopy = createPolymorphicComponent<'button', ButtonCopyProps>(_ButtonCopy)
